import 'react-toastify/dist/ReactToastify.css'

import TableCompanyUsers from '../../components/table/users/TableCompanyUsers'

const CreateCompanyUser = () => {
  return <TableCompanyUsers />
}

export default CreateCompanyUser
